module.exports = {"__schema":{"types":[{"kind":"INTERFACE","name":"Node","possibleTypes":[{"name":"User"},{"name":"Anal"},{"name":"Study"},{"name":"StaticPdata"},{"name":"UserPdata"},{"name":"UserPdataRow"},{"name":"UserCdata"},{"name":"UserCdataRow"},{"name":"Results"},{"name":"AnalPlot"},{"name":"SearchSource"},{"name":"SearchStats"},{"name":"Clusters"},{"name":"CommunityAnal"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/fragmentTypes.json
// module id = 684
// module chunks = 13